// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"45b23e66","703":"ecb69dc2"}[chunkId] + ".chunk.js";
};